import { useSelector } from 'react-redux'

import { otherIdentifiersSelector } from '@/selectors'
import { translate } from '@/utils/translations'

const OtherIdentifiers = () => {
  const otherIdentifiers = useSelector(otherIdentifiersSelector)

  return (
    <If condition={otherIdentifiers}>
      <div>
        <h3 className='mb-3'>
          {translate('common.additional_isbns')}
        </h3>
        <span className='remove-ios-formatting additional-isbns'>
          {otherIdentifiers}
        </span>
      </div>
    </If>
  )
}

export default OtherIdentifiers
